export default "__VITE_ASSET__b3c9c208__"